var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.00122C12.837 1.00122 12.2011 1.26461 11.7322 1.73345C11.2634 2.20229 11 2.83818 11 3.50122V13.5012C11 14.1643 11.2634 14.8001 11.7322 15.269C12.2011 15.7378 12.837 16.0012 13.5 16.0012C14.163 16.0012 14.7989 15.7378 15.2678 15.269C15.7366 14.8001 16 14.1643 16 13.5012C16 12.8382 15.7366 12.2023 15.2678 11.7335C14.7989 11.2646 14.163 11.0012 13.5 11.0012H3.5C2.83696 11.0012 2.20107 11.2646 1.73223 11.7335C1.26339 12.2023 1 12.8382 1 13.5012C1 14.1643 1.26339 14.8001 1.73223 15.269C2.20107 15.7378 2.83696 16.0012 3.5 16.0012C4.16304 16.0012 4.79893 15.7378 5.26777 15.269C5.73661 14.8001 6 14.1643 6 13.5012V3.50122C6 2.83818 5.73661 2.20229 5.26777 1.73345C4.79893 1.26461 4.16304 1.00122 3.5 1.00122C2.83696 1.00122 2.20107 1.26461 1.73223 1.73345C1.26339 2.20229 1 2.83818 1 3.50122C1 4.16426 1.26339 4.80015 1.73223 5.26899C2.20107 5.73783 2.83696 6.00122 3.5 6.00122H13.5C14.163 6.00122 14.7989 5.73783 15.2678 5.26899C15.7366 4.80015 16 4.16426 16 3.50122C16 2.83818 15.7366 2.20229 15.2678 1.73345C14.7989 1.26461 14.163 1.00122 13.5 1.00122Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryActive);
export default __webpack_public_path__ + "static/media/inventory-active.2ae27efd75ee9458638efe2f26c391c8.svg";
export { ForwardRef as ReactComponent };